import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { Helmet } from "react-helmet-async";
import Swal from "sweetalert2";

const DaftarPengguna = () => {
    const [role, setRole] = useState("Pendidik");
    const [error, setError] = useState('');
    const [passwordbaru, setpasswordbaru] = useState('');
    const [formData, setFormData] = useState({
        rombel_id: "",
        initial: "",
        nama_rombel: "",
        tingkat: "10",
        jenis_rombel: "Umum"
    });
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // State untuk loading

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // Aktifkan loading
console.log(formData)
        Swal.fire({
            title: "Menyimpan...",
            text: "Mohon tunggu sebentar.",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/pengguna/updateakses`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                   
                },
              credentials: 'include',
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data");
            }

            const result = await response.json();

            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.datatable-table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });

            setError('');
            setFormData({});

        } catch (error) {
            Swal.fire("Error!", error.message || 'Terjadi kesalahan', "error");
            setError(error.message || 'Terjadi kesalahan');
        } finally {
            setIsLoading(false); // Matikan loading setelah proses selesai
        }
    };

    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
    };


    useEffect(() => {
        $('.datatable-table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/pengguna/getpengguna?role=${role}`,
                type: "GET",
                headers: {
                    'Content-Type': 'application/json',
                  
                },
                xhrFields: {
      withCredentials: true, // agar cookie/session dikirim kalau pakai credentials
    },
                dataSrc: "data",
            },
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.nama}</b>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${data.akses}</b>`;
                    }
                },

                {
                    data: null,
                    render: function (data, type, row) {

                        return `
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${JSON.stringify(row)}'>
                                <i class="ti ti-edit"></i>
                            </a>
                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });

        return () => {
            if ($.fn.dataTable.isDataTable('.datatable-table')) {
                $('.datatable-table').DataTable().destroy();
            }
        };
    }, [role]);


    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");

        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                console.log({ rombel_id: id })
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapuskelas`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        
                    },
                    credentials: 'include',
                    body: JSON.stringify({ rombel_id: id })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                            $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                        } else {
                            Swal.fire("Gagal!", data.message, "error");
                        }
                    })
                    .catch(error => {
                        Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                    });
            }
        });
    });

    const ubahrole = (vl) => {
        setRole(vl)
          
    };

    return (
        <>
            <Helmet>
                <title>Pengguna Griya Vidya</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className='row mb-3 align-items-center'>
                                            <div className="col"><small className="text-muted">Refrensi</small><h3>Pengguna / {role}</h3></div>

                                         <div className='col-auto'>
                                            <div className="btn-group" role="group">
                                                <button type="button" onClick={() => ubahrole("Pendidik")} className="btn btn-danger">
                                                {role=="Pendidik" && (<i className='ti ti-check'></i>)} Pendidik
                                                </button>
                                                <button type="button" onClick={() => ubahrole("Pd")} className="btn btn-warning">
                                                {role=="Pd" && (<i className='ti ti-check'></i>)} Peserta Didik
                                                </button>
                                                <button type="button" onClick={() => ubahrole("Operator")} className="btn btn-primary">
                                                {role=="Operator" && (<i className='ti ti-check'></i>)} Operator
                                                </button>
                                            </div>
                                            </div>

                                        </div>
                                        <hr />
                                        {/* Tabel kelas */}
                                        <table className="table table-hover datatable-table" >
                                            <thead>
                                                <tr>
                                                    <th width="50">#</th>
                                                    <th scope="col">Nama</th>
                                                    <th width="50"><center>Akses</center></th>

                                                    <th width="50"><center>Action</center></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                        {/* Tampilkan error jika ada */}
                                        {error && <div className="alert alert-danger">{error}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal Input/Edit */}
                <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog">
                        <form onSubmit={handleSubmit} className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{isEditing ? "Edit Pengguna" : "Tambah Pengguna"}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">No Whastsapp</label>
                                    <input type="text" className="form-control" name="wa_number" value={formData.wa_number||formData.uid} disabled readOnly onChange={handleChange} required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Nama</label>
                                    <input type="text" className="form-control" name="nama" value={formData.nama} onChange={handleChange} required />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Akses Utama</label>
                                   <select
                                        name="akses"
                                        className="form-select"
                                        value={formData.akses}
                                        onChange={(e) =>
                                            setFormData({
                                            ...formData,
                                            akses: e.target.value
                                            })
                                        }
                                        required
                                        >
                                        <option value="Pendidik">Pendidik</option>
                                        <option value="Pd">Peserta Didik</option>
                                        <option value="Operator">Operator</option>
                                        </select>
                                </div>
                                {/* <div className="mb-3">
                                    <label className="form-label">Akses Tambahan</label>
                                    <div class="new-task">
                                        <div class="to-do-list mb-3">
                                            <div class="d-inline-block">
                                                <div class="check-task form-check">
                                                    <input type="checkbox" class="form-check-input" id="customCheck1" />
                                                    <label class="form-check-label" for="customCheck1">Guru</label>
                                                </div>

                                                <div class="check-task form-check">
                                                    <input type="checkbox" class="form-check-input" id="customCheck1" />
                                                    <label class="form-check-label" for="customCheck1">Wali Kelas</label>
                                                </div>
                                                <div class="check-task form-check">
                                                    <input type="checkbox" class="form-check-input" id="customCheck1" />
                                                    <label class="form-check-label" for="customCheck1">Waka Kurikulum</label>
                                                </div>
                                                <div class="check-task form-check">
                                                    <input type="checkbox" class="form-check-input" id="customCheck1" />
                                                    <label class="form-check-label" for="customCheck1">Waka Kesiswaan</label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="mb-3">

                                    <button type="button" class="btn btn-danger" onClick={
                                        setpasswordbaru("")
                                    }>Reset Password</button>
                                    <br/>
                                    Password Baru : {passwordbaru}
                                </div> */}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                    Batal
                                </button>
                                <button type="onSubmit" className="btn btn-primary"  disabled={isLoading}>

                                    {isLoading ? "Menyimpan..." : isEditing ? "Update" : "Simpan"}

                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </>
    );
};

export default DaftarPengguna;
